import React from 'react';

import Popover from 'design-system/Popover';
// TODO: Import @material-ui from design-system folder
// eslint-disable-next-line restrict-imports/restrict-imports
import { PopoverOrigin } from '@material-ui/core/Popover';

interface ToolSidebarButtonPopoverProps {
  popover: React.ReactNode;
  targetOpen: React.ReactElement;
  targetClosed: React.ReactElement;
  isDisabled?: boolean;
  isOpen?: boolean;
}

const ToolSidebarButtonPopover: React.FC<ToolSidebarButtonPopoverProps> = props => {
  const { popover, targetOpen, targetClosed, isDisabled, isOpen } = props;

  // This positions the popover to the right of the icon
  const anchorOrigin: PopoverOrigin = {
    vertical: 'center',
    horizontal: 'right',
  };

  const transformOrigin: PopoverOrigin = {
    vertical: 'center',
    horizontal: -12,
  };

  return (
    <Popover
      targetOpen={targetOpen}
      targetClosed={targetClosed}
      popover={popover}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      disabled={isDisabled}
      isOpen={isOpen}
    />
  );
};
export default ToolSidebarButtonPopover;
